import React from 'react';
import styled from '../../styled';
import { COLORS } from '../../themes/color';

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
`;

const StatCard = styled('div')`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 12px;
`;

const BenefitValue = styled('div')`
  font-size: 48px;
  font-weight: 700;
  color: ${COLORS.PRIMARY};
  line-height: 1.2;
  margin: 0;

  @media (max-width: 960px) {
    font-size: 40px;
  }

  @media (max-width: 600px) {
    font-size: 32px;
  }
`;

const ExplanationText = styled('p')`
  font-size: 16px;
  line-height: 1.6;
  color: #4f4f4f;
  margin: 0;
`;

export type BenefitItem = {
  benefitValue: string;
  explanation: string;
};

export type BenefitsListProps = {
  benefits: BenefitItem[];
  className?: string;
};

export const BenefitsList = ({ benefits, className }: BenefitsListProps) => {
  return (
    <Grid className={className}>
      {benefits.map((benefit, index) => (
        <StatCard key={index}>
          <BenefitValue>{benefit.benefitValue}</BenefitValue>
          <ExplanationText>{benefit.explanation}</ExplanationText>
        </StatCard>
      ))}
    </Grid>
  );
};
